// extracted by mini-css-extract-plugin
export default {"homepageStyle":"homePage_homepageStyle__WP-Y1","homepageStyleMob":"homePage_homepageStyleMob__iJ9CT","modal":"homePage_modal__zSdUB","modalMob":"homePage_modalMob__yq8RR"};